<!--
 * @Description: 
 * @Date: 2020-07-27 11:25:02
-->
<template>
  <div class="home">
    <div>
      <banner-img :banner-img="imgList" v-if="imgList.length > 0"></banner-img>
      <van-search
        placeholder="搜索内容"
        show-action
        @click.native="$router.push({ name: 'search' })"
      >
        <template #action>
          <img
            class="home__person"
            src="@/static/img/person.png"
            @click.stop="toPerson"
          />
        </template>
      </van-search>
      <div style="background:#fff">
        <contentList v-if="showList"></contentList>
      </div>
    </div>
  </div>
</template>
<script>
import { index } from '@/api/ajax';
import BannerImg from './components/swiper.vue'; // 轮播组件
import list from './components/list';
import tab from './components/tab';
import contentList from '@/components/list/contentList.vue';
import { yshLogin } from '@/service/login';

export default {
  data() {
    return {
      showList: true,
      imgList: [] // banner数据
    };
  },
  computed: {},
  methods: {
    toPerson() {
      this.$router.push({ name: 'person' });
    },
    jump(item) {
      // if (item.link.name === 'activityList') {
      //   this.$toast('敬请期待~');
      //   return;
      // }
      this.$router.push(item.link);
    },
    async init() {
      // TODO: banner用在了拦截白名单上。应放到路由上处理
      try {
        let {
          data: { data }
        } = await index.banner();
        this.imgList = data;
        this.showList = true;
      } catch (e) {
        this.showList = false;
      }
    }
  },
  components: {
    BannerImg,
    list,
    tab,
    contentList
  },
  created() {
    this.init();
    // 注册YSH来源用户
    yshLogin.call(this);
  },
  async activated() {
    this.init();
    let {
      pdata: { channelName, bgUrl }
    } = await index.channelData({
      channelNo: this.$route.params.channelNo
    });
    this.$wxShare({
      title: channelName,
      imgUrl: bgUrl,
      desc: `欢迎进入${channelName}`
    });
  }
};
</script>
<style lang="less" scoped>
.home {
  // width: 100vw;
  min-height: 100vh;
  background: #fff;
  padding-top: 0.1px;
  &__person {
    width: 0.55rem;
    height: 0.55rem;
  }

  .cards {
    display: flex;
    justify-content: space-between;
    background: #fff;
    padding: 0.27rem 0.43rem;
    li {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 4.36rem;
      height: 1.81rem;
      border-radius: 0.21rem;
      padding: 0.32rem;
      * {
        line-height: 1;
      }
      h5 {
        color: #fff;
        font-size: 0.48rem;
        margin-bottom: 0.32rem;
      }
      p {
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.37rem;
      }
    }
  }
  /deep/ .van-tabs__nav {
    .van-tab__text {
      color: #959599;
      font-size: 0.43rem;
    }
    .van-tabs__line {
      background-color: #3667ec;
    }
    .van-tab--active {
      span {
        color: #3667ec;
      }
    }
  }
  /deep/ .hidden-tab {
    & > div:first-child {
      display: none;
    }
  }
  /deep/ .van-search {
    background-color: #ededed;
    .van-search__content {
      border-radius: 0.32rem;
    }
  }
}
</style>
